// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "6900d8ad27567c0a20e9212803436f9a" + ".js";
};